import { format } from 'date-fns'
import PropTypes from 'prop-types'
import { findMatchBetweenPlayers, getHomeAwayStatus } from '../../utils/match'

const OpponentListPopup = ({
  isOpen,
  selectedSlotTime,
  selectedSlotOpponents,
  formatTimeSlot,
  onClose,
  onSelectOpponent,
  getMatchProposalForOpponent,
  getScheduledMatchForOpponent,
  allMatches,
  currentUserPlayerId,
}) => {
  if (!isOpen) return null

  return (
    <div className="opponent-list-overlay" onClick={onClose}>
      <div
        className="opponent-list-popup"
        onClick={(e) => {
          if (e && e.stopPropagation) {
            e.stopPropagation()
          }
        }}
      >
        <div className="opponent-list-header">
          <h4>Available Opponents</h4>
          {selectedSlotTime && (
            <p className="time-info">
              {format(selectedSlotTime.date, 'EEEE, MMM d')} at{' '}
              {formatTimeSlot(selectedSlotTime.timeSlot)}
            </p>
          )}
          <button className="close-btn" onClick={onClose}>
            ×
          </button>
        </div>
        <div className="opponent-list-content">
          {selectedSlotOpponents.map((opponent) => {
            const proposal = selectedSlotTime
              ? getMatchProposalForOpponent(
                  opponent.id,
                  selectedSlotTime.date,
                  selectedSlotTime.timeSlot.hour,
                )
              : null
            const scheduledMatch = selectedSlotTime
              ? getScheduledMatchForOpponent(
                  opponent.id,
                  selectedSlotTime.date,
                  selectedSlotTime.timeSlot.hour,
                )
              : null

            const matchWithOpponent = findMatchBetweenPlayers(
              allMatches,
              currentUserPlayerId,
              opponent.id,
            )

            const { isHome: isCurrentPlayerHome, icon: homeAwayIcon } =
              getHomeAwayStatus(matchWithOpponent, currentUserPlayerId)

            return (
              <div key={opponent.id} className="opponent-list-item">
                <div className="opponent-info">
                  <div className="opponent-name">
                    {opponent.first_name} {opponent.last_name}
                    {homeAwayIcon && matchWithOpponent && (
                      <span
                        className={`home-away-indicator ${
                          isCurrentPlayerHome ? 'home' : 'away'
                        }`}
                        title={
                          isCurrentPlayerHome
                            ? 'You host this match'
                            : 'You travel to their court'
                        }
                        aria-label={
                          isCurrentPlayerHome ? 'Home match' : 'Away match'
                        }
                      >
                        {homeAwayIcon}
                      </span>
                    )}
                  </div>
                </div>
                <div className="opponent-actions">
                  {scheduledMatch ? (
                    <div className="match-status scheduled">
                      ✓ Scheduled Match
                    </div>
                  ) : proposal && proposal.status === 'pending' ? (
                    <div className="match-status pending">
                      {proposal.is_sent_by_user
                        ? '→ Proposal Sent'
                        : '← Proposal Received'}
                    </div>
                  ) : (
                    <>
                      <button
                        className="btn btn-primary btn-sm"
                        onClick={() => onSelectOpponent(opponent)}
                      >
                        Propose Match
                      </button>
                      {proposal && proposal.status === 'declined' && (
                        <span className="text-danger ms-2">✕ Rejected</span>
                      )}
                      {proposal && proposal.status === 'expired' && (
                        <span className="text-warning ms-2">⚠️ Expired</span>
                      )}
                    </>
                  )}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </div>
  )
}

OpponentListPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  selectedSlotTime: PropTypes.shape({
    date: PropTypes.instanceOf(Date).isRequired,
    timeSlot: PropTypes.shape({
      hour: PropTypes.number.isRequired,
      minute: PropTypes.number.isRequired,
    }).isRequired,
  }),
  selectedSlotOpponents: PropTypes.array.isRequired,
  formatTimeSlot: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelectOpponent: PropTypes.func.isRequired,
  getMatchProposalForOpponent: PropTypes.func.isRequired,
  getScheduledMatchForOpponent: PropTypes.func.isRequired,
  allMatches: PropTypes.array.isRequired,
  currentUserPlayerId: PropTypes.number.isRequired,
}

export default OpponentListPopup
